import { createAlgolia } from '@24orebs/algolia';
import {
	PUBLIC_ALGOLIA_APP_ID,
	PUBLIC_ALGOLIA_SEARCH_API_KEY,
	PUBLIC_ALGOLIA_COURSES_INDEX_NAME,
	PUBLIC_ALGOLIA_INSTRUCTORS_INDEX_NAME,
	PUBLIC_ALGOLIA_EVENTS_INDEX_NAME,
	PUBLIC_ALGOLIA_NEWS_INDEX_NAME,
	PUBLIC_ALGOLIA_PARTNERS_INDEX_NAME
} from '$env/static/public';

/**
 * The app's Algolia runtime — the only place in `apps/web` that reads Algolia
 * environment variables. Everything else refers to indices by their logical
 * key (`algolia.indices.courses`), which is type-checked.
 */
export const algolia = createAlgolia({
	appId: PUBLIC_ALGOLIA_APP_ID,
	searchApiKey: PUBLIC_ALGOLIA_SEARCH_API_KEY,
	indices: {
		courses: PUBLIC_ALGOLIA_COURSES_INDEX_NAME,
		instructors: PUBLIC_ALGOLIA_INSTRUCTORS_INDEX_NAME,
		events: PUBLIC_ALGOLIA_EVENTS_INDEX_NAME,
		news: PUBLIC_ALGOLIA_NEWS_INDEX_NAME,
		partners: PUBLIC_ALGOLIA_PARTNERS_INDEX_NAME
	}
});
